import { useMemo } from "react"

import { User } from "shared/types/__generated__/graphql"

import { TeamMember } from "entities/team-members/types/TeamMember"

import { TeamInitialsListProps } from "../TeamInitialsList"
import { TeamInitialsListViewProps } from "../TeamInitialsListView"

export function useTeamInitialsList({
  team,
  shownMemberCount = 3,
  ignoredUserEmails
}: TeamInitialsListProps): TeamInitialsListViewProps {
  const teamMembers = useMemo<TeamMember[]>(() => {
    return team.memberships.filter(member =>
      Array.isArray(ignoredUserEmails)
        ? !ignoredUserEmails?.includes(member.user?.email || "")
        : ignoredUserEmails !== member.user?.email
    )
  }, [team.memberships, ignoredUserEmails])

  const additionalUserCount = useMemo(() => {
    return teamMembers.length > shownMemberCount
      ? teamMembers.length - shownMemberCount
      : 0
  }, [teamMembers.length, shownMemberCount])

  const usersToShow = useMemo<User[]>(
    () =>
      teamMembers
        .slice(0, shownMemberCount)
        .map(member => member.user)
        .filter(Boolean) as User[],
    [teamMembers, shownMemberCount]
  )

  return { usersToShow, additionalUserCount }
}
